
<template>
<markdown-render v-if="guide" :source="guide"></markdown-render>
</template>

<script>
import { mapState } from 'vuex'
import MarkdownRender from '../../MarkdownRender'

export default {
  components:{
    "markdown-render": MarkdownRender
  },

  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env],
          auth: state => state.serviceModule.authentication
      }
    ),
    guide(){
        const credentials = this.auth.Credentials()
        return getPyScript()
            .replace('{__hostname__}', this.http.host )
            .replace('{__region__}', this.http.region )
            .replace('{__endpoint__}', `https://${this.http.host}/v1/data` )
            .replace('{__aws_session_token__}', credentials.sessionToken)
            .replace('{__aws_access_secret_access_key__}', credentials.secretAccessKey)
            .replace('{__aws_access_key_id__}', credentials.accessKeyId)
            .replace('{__expire__}', (new Date(parseInt(credentials.expiration))+'').split('GMT')[0]);
    }
  },
  data(){
    return {
    }
  },

  mounted(){

  }
  
}


function getPyScript() { return "                                                                                       \n\
# How to download data                                              \n\
Use below python script in order to download programmatically daily data sent by devices. Before running it, install 'requests' python library in your local machine (i.e. 'pip install requests')\n\
\n\
**Note**: *(access_key, secret_key, session_token)* credentials are temporary (current credentials: {__expire__}).When they will expire, please reload the browser page.\n\
```\n\
\n\
from fileinput import filename\n\
import sys, os, base64, datetime, hashlib, hmac\n\
import requests # pip install requests\n\
\n\
# Input values.\n\
method              = 'GET'\n\
service             = 'execute-api'\n\
host                = '{__hostname__}'\n\
region              = '{__region__}'\n\
endpoint            = '{__endpoint__}'\n\
\n\
# CUSTOMIZE VALUES AS YOU WANT. \n\
# Note 1: only one device ID accepted (encode it if needed). \n\
# Note 2: don't change parameters order.\n\
# Note 3: for example, following values will download data sent by 'mydeviceid' device during 29th and 30th Sept '22 - devices=mydeviceid&timestampEnd=1664550449000&timestampStart=1664464049000\n\
request_parameters  = 'devices={__device_id__}&timestampEnd={__last_day_millisec_timestamp__}&timestampStart={__begin_day_millisec_timestamp__}'\n\
filename            = '{__filename__}'\n\
\n\
\n\
\n\
access_key          = '{__aws_access_key_id__}'\n\
secret_key          = '{__aws_access_secret_access_key__}'\n\
session_token       = '{__aws_session_token__}'\n\
\n\
# Prepare HTTP request.\n\
def sign(key, msg):\n\
    return hmac.new(key, msg.encode('utf-8'), hashlib.sha256).digest()\n\
\n\
def getSignatureKey(key, dateStamp, regionName, serviceName):\n\
    kDate = sign(('AWS4' + key).encode('utf-8'), dateStamp)\n\
    kRegion = sign(kDate, regionName)\n\
    kService = sign(kRegion, serviceName)\n\
    kSigning = sign(kService, 'aws4_request')\n\
    return kSigning\n\
\n\
t = datetime.datetime.utcnow()\n\
amzdate = t.strftime('%Y%m%dT%H%M%SZ')\n\
datestamp = t.strftime('%Y%m%d')\n\
canonical_uri = '/v1/data'\n\
canonical_querystring = request_parameters\n\
canonical_headers = 'host:' + host + '\n' + 'x-amz-date:' + amzdate + '\n' + 'x-amz-security-token:' + session_token + '\n'\n\
signed_headers = 'host;x-amz-date;x-amz-security-token'\n\
payload_hash = hashlib.sha256(('').encode('utf-8')).hexdigest()\n\
canonical_request = method + '\n' + canonical_uri + '\n' + canonical_querystring + '\n' + canonical_headers + '\n' + signed_headers + '\n' + payload_hash\n\
algorithm = 'AWS4-HMAC-SHA256'\n\
credential_scope = datestamp + '/' + region + '/' + service + '/' + 'aws4_request'\n\
string_to_sign = algorithm + '\n' +  amzdate + '\n' +  credential_scope + '\n' +  hashlib.sha256(canonical_request.encode('utf-8')).hexdigest()\n\
signing_key = getSignatureKey(secret_key, datestamp, region, service)\n\
signature = hmac.new(signing_key, (string_to_sign).encode('utf-8'), hashlib.sha256).hexdigest()\n\
authorization_header = algorithm + ' ' + 'Credential=' + access_key + '/' + credential_scope + ', ' +  'SignedHeaders=' + signed_headers + ', ' + 'Signature=' + signature\n\
headers = {'x-amz-date':amzdate, 'Authorization':authorization_header, 'X-Amz-Security-Token': session_token}\n\
request_url = endpoint + '?' + canonical_querystring\n\
\n\
# Send HTTP request.\n\
print('\nBEGIN REQUEST++++++++++++++++++++++++++++++++++++')\n\
print('Request URL = ' + request_url)\n\
r = requests.get(request_url, headers=headers)\n\
\n\
print('\nRESPONSE++++++++++++++++++++++++++++++++++++')\n\
print('Response code: %d\n' % r.status_code)\n\
print(r.text)\n\
\n\
# Save result.\n\
with open(filename, 'wb') as f:\n\
    f.write(r.content)\n\
print('\SAVED FILE++++++++++++++++++++++++++++++++++++')\n\
print(filename)\n\
\n\
```\n\
"
}

</script>
